const PropTypes = require('prop-types');
const React = require('react');
const { Modal, Tracker } = require('@reverbdotcom/discovery-ui');
const UrlHelpers = require('components/shared/url_helpers.js');
const OfferInput = require('components/offers/offer_input.jsx');
const Money = require('components/shared/money');
const { UI } = require('components/legacy/ui.js');
const User = require('components/user.js');
const { HashUtil } = require('@reverbdotcom/discovery-ui');
const { isNaN } = require('lodash');

// const US_COUNTRY_CODE = 'US';

class OfferModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      countriesForSelect: [],
      selectedCountry: props.selectedCountry,
      selectedState: props.selectedState,
      optionalMessage: props.message,
      price: { },
      agreeToPay: props.agreeToPay,
      successfulResponse: false,
      error: false,
      errorMessage: '',
      disabledSaveButton: false,
      shipping: { amount: props.estimatedShippingAmount, display: '' },
      quantity: 1,
      layawaySelected: false,
      layawayTerms: '',
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOptionalMessageChange = this.handleOptionalMessageChange.bind(this);
    this.updatePriceAndShipping = this.updatePriceAndShipping.bind(this);
    this.handleSelectedCountryChange = this.handleSelectedCountryChange.bind(this);
    this.handleSelectedStateChange = this.handleSelectedStateChange.bind(this);
    this.handleAddLayaway = this.handleAddLayaway.bind(this);
    this.updateLayawayTerms = this.updateLayawayTerms.bind(this);
  }

  componentDidMount() {
    this.fetchCountriesForSelect();
  }

  get subClass() {
    if (this.props.forSeller) {
      return 'offer-modal';
    }

    return null;
  }

  get totalPrice() {
    let priceFloat = parseFloat(this.state.price.amount, 10);
    let shippingFloat = parseFloat(this.state.shipping.amount, 10);

    if (isNaN(priceFloat)) { priceFloat = 0; }
    if (isNaN(shippingFloat)) { shippingFloat = 0; }

    const total = ((this.state.quantity * priceFloat) + shippingFloat);
    return total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  get canViewQuantity() {
    return !!this.props.product.availableQuantity && this.props.forSeller;
  }

  totalOfferPrice() {
    const totalForQuantity = this.state.price.amount * this.state.quantity;
    return Money.parse(totalForQuantity, this.props.shopCurrency).toString();
  }

  updatePriceAndShipping(updatedTotals) {
    if (updatedTotals.price) {
      this.setState({
        price: updatedTotals.price,
      });
    }

    if (updatedTotals.shipping) {
      this.setState({
        shipping: updatedTotals.shipping,
      });
    }

    if (updatedTotals.quantity) {
      this.setState({
        quantity: updatedTotals.quantity,
      });
    }
  }

  updateLayawayTerms(event) {
    this.setState({
      layawayTerms: event.target.value,
    });
  }

  fetchCountriesForSelect() {
    Reverb.APIRequest.V3.get(UrlHelpers.countriesPath).done((response) => {
      this.setState({
        countriesForSelect: response.countries,
      });
    });
  }

  handleCloseModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  handleOpenModal(e) {
    if (!UI.isLoggedIn()) {
      User.showInlineRegistrationOrLogin(e, e.target);
    } else {
      this.setState({
        isModalOpen: true,
      });

      Tracker.view({ name: 'modal_make_offer' });
    }
  }

  handleAgreeToPay() {
    this.setState({
      agreeToPay: !this.state.agreeToPay,
    });
  }

  handleSelectedCountryChange(e) {
    this.setState({
      selectedCountry: e.target.value,
    });
  }

  handleSelectedStateChange(e) {
    this.setState({
      selectedState: e.target.value,
    });
  }

  handleAddLayaway() {
    this.setState({
      layawaySelected: true,
    });
  }

  offerParams() {
    return (
      {
        price: {
          currency: this.props.shopCurrency,
          amount: this.state.price.amount,
        },
        shipping_price: {
          currency: this.props.shopCurrency,
          amount: this.state.shipping.amount,
        },
        message: this.state.optionalMessage,
        country_code: this.state.selectedCountry,
        region_code: this.state.selectedState,
        quantity: this.state.quantity,
        layaway_terms_slug: this.state.layawayTerms,
      }
    );
  }

  handleOptionalMessageChange(e) {
    this.setState({
      optionalMessage: e.target.value,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({
      disabledSaveButton: true,
    });

    const requestPath = this.props.conversationId ?
      UrlHelpers.offerFromConversationPath(this.props.conversationId) :
      UrlHelpers.placeOfferPath(this.props.product.id);

    Reverb.APIRequest.V3.post(
      requestPath,
      this.offerParams(),
    ).done(() => {
      this.handleCloseModal();
      this.setState({
        successfulResponse: true,
        error: false,
        errorMessage: '',
      });
    }).error((response) => {
      this.setState({
        error: true,
        errorMessage: HashUtil.getSafely(response, 'responseJSON.message'),
        disabledSaveButton: false,
      });
    });
  }

  countryOptionsForSelect() {
    return (
      this.state.countriesForSelect.map(country => (
        <option
          key={country.country_code}
          value={country.country_code}
        >
          {country.name}
        </option>
      ))
    );
  }

  errorMessage() {
    if (this.state.errorMessage) {
      return this.state.errorMessage;
    }

    return I18n.t('js.offerModal.error');
  }

  submitButtonText() {
    if (this.state.disabledSaveButton) {
      return I18n.t('js.wait');
    }

    return I18n.t('js.offerModal.submit_offer');
  }

  renderMessageTextArea() {
    return (
      <div className="offer-modal__message">
        <textarea
          onChange={this.handleOptionalMessageChange}
          value={this.state.optionalMessage}
          className="wide"
          rows="4"
          name="message"
          required={this.props.forSeller}
        />
      </div>
    );
  }

  renderAcceptanceLabelText() {
    if (this.props.product.inLiveSale) {
      return (
        <span>
          {I18n.t('js.offerModal.agreeToPay')}
          <br />
          {I18n.t('js.offerModal.saleDiscountNotice')}
        </span>
      );
    }

    return I18n.t('js.offerModal.agreeToPay');
  }

  renderAgreeToPay() {
    if (this.props.forSeller) { return null; }

    return (
      <div className="offer-modal__terms">
        <div className="offer-modal__checkbox">
          <input
            type="checkbox"
            id="offer-modal-terms-checkbox"
            checked={this.state.agreeToPay}
            onChange={() => this.handleAgreeToPay()}
            required
          />
          <label htmlFor="offer-modal-terms-checkbox">
            {this.renderAcceptanceLabelText()}
          </label>
        </div>
      </div>
    );
  }

  renderProductDetails() {
    if (!this.props.forSeller) { return null; }

    return (
      <div className="offer-modal__product">
        <div className="offer-modal__product__info">
          <div className="offer-modal__product__thumb">
            <img alt={this.props.product.title} src={this.props.product.thumbnailImageUrl} />
          </div>
          <p className="offer-modal__product__title">
            {this.props.product.title}
          </p>
          <div className="offer-modal__product__details">
            <table>
              <tbody>
                <tr>
                  <td>{I18n.t('js.offerModal.asking')}</td>
                  <td>{this.props.product.displayPrice}</td>
                </tr>
                <tr>
                  <td>{I18n.t('js.offerModal.shipping')}</td>
                  <td>{this.props.product.shippingPrice}</td>
                </tr>
                <tr>
                  <td>{I18n.t('js.offerModal.condition')}</td>
                  <td>{this.props.product.condition}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    if (this.state.error) {
      return (
        <div className="mb-1">
          <p className="offer-modal__alert offer-modal__alert--error">
            {this.errorMessage()}
          </p>
        </div>
      );
    }

    return null;
  }

  renderMessageLabel() {
    return this.props.forSeller ? I18n.t('js.offerModal.messageRequiredText') : I18n.t('js.offerModal.optionalMessageLabelText');
  }

  renderOfferModalBody() {
    return (
      <div className="offer-modal__body">
        {this.renderError()}
        <div className="offer-modal__offer-input">
          <OfferInput
            nudgeEnabled={!this.props.forSeller}
            productPrice={this.props.product.price}
            shippingSummary={this.props.shippingSummary}
            shippingPrice={this.state.shipping.amount}
            shippingEditable={this.props.forSeller}
            currency={this.props.userCurrency}
            shopCurrency={this.props.shopCurrency}
            onChange={this.updatePriceAndShipping}
            totalPrice={this.totalPrice}
            availableQuantity={this.props.product.availableQuantity}
            showQuantity={this.canViewQuantity}
            renderInputWithQuantity={this.props.forSeller}
          />
        </div>
        <label className="offer-modal__label">
          {this.renderMessageLabel()}
        </label>
        {this.renderMessageTextArea()}
        {this.renderLayawayTerms()}
        {this.renderAgreeToPay()}
        {this.renderSubtext()}
      </div>
    );
  }

  renderSubtext() {
    if (this.props.forSeller) {
      return (
        <p className="offer-modal__response-timeline">
          {I18n.t('js.offerModal.sellerSubtext', { recipientName: this.props.recipientName })}
        </p>
      );
    }

    return (
      <p className="offer-modal__response-timeline">
        {I18n.t('js.offerModal.replyTimeline', { shopName: this.props.shopName, expiration_time: I18n.t('js.offerModal.expiration_time') })}
      </p>
    );
  }

  renderLayawayTerms() {
    if (!this.props.showLayawayForm || !this.props.forSeller) { return null; }

    if (!this.state.layawaySelected) {
      return (
        <a href='#' onClick={this.handleAddLayaway}>{I18n.t('js.offerModal.addLayawayTerms')}</a>
      );
    }

    return (
      <div>
        <label>{I18n.t('js.offerModal.layawayTerms')}</label>
        <select
          name="layawayTerms"
          id="layaway_terms"
          defaultValue="None"
          onChange={this.updateLayawayTerms}
        >
          {this.props.layawayOptions.map(term =>
            <option key={term[0]} value={term[0]}>{term[1]}</option>)}
        </select>
      </div>
    );
  }

  renderOfferModalFooter() {
    return (
      <div className="offer-modal__footer">
        <button
          className="offer-modal__submit-button"
          type="submit"
          disabled={this.state.disabledSaveButton}
        >
          {this.submitButtonText()}
        </button>
      </div>
    );
  }

  renderOfferModal() {
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        onRequestClose={this.handleCloseModal}
        contentLabel="Modal"
        paddedBody
        headerTitle={this.props.headerText}
        subClass={this.subClass}
      >
        {this.renderProductDetails()}
        <form onSubmit={this.handleSubmit} className="offer-modal">
          {this.renderOfferModalBody()}
          {this.renderOfferModalFooter()}
        </form>
      </Modal>
    );
  }

  renderUserAction() {
    if (this.state.successfulResponse) {
      if (this.props.forSeller) {
        return window.location.reload();
      }

      return (
        <p className="offer-modal__alert offer-modal__alert--success">
          {I18n.t('js.offerModal.successfulOfferResponse', { displayPrice: this.totalOfferPrice() })}
        </p>
      );
    }

    return (
      <button
        className={this.props.buttonClasses}
        data-make-offer-link
        onClick={this.handleOpenModal}
        type="button"
      >
        {this.props.buttonText}
      </button>
    );
  }

  render() {
    return (
      <div>
        {this.renderUserAction()}
        {this.renderOfferModal()}
      </div>
    );
  }
}

OfferModal.defaultProps = {
  buttonClasses: 'offer-modal__trigger wide',
  buttonText: I18n.t('js.offerModal.makeAnOffer'),
  headerText: I18n.t('js.offerModal.makeAnOffer'),
  conversationId: '',
  forSeller: false,
  recipientName: '',
  message: '',
  showLayawayForm: false,
};

OfferModal.propTypes = {
  estimatedShippingAmount: PropTypes.string.isRequired,
  userCurrency: PropTypes.string.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  selectedState: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  shopName: PropTypes.string.isRequired,
  shippingEditable: PropTypes.bool.isRequired,
  shippingSummary: PropTypes.string.isRequired,
  agreeToPay: PropTypes.bool.isRequired,
  buttonClasses: PropTypes.string,
  buttonText: PropTypes.string,
  headerText: PropTypes.string,
  conversationId: PropTypes.string,
  forSeller: PropTypes.bool,
  recipientName: PropTypes.string,
  message: PropTypes.string,
  showLayawayForm: PropTypes.bool,
  layawayOptions: PropTypes.array.isRequired,
};

module.exports = OfferModal;



// WEBPACK FOOTER //
// ./javascripts/components/offers/offer_modal.jsx